import { Button, Tag } from "@rio-cloud/rio-uikit";
import { IContractDetailsVolksEssential } from "../../../../models/volksPlanEssential";
import { Card } from "@mui/material";
import { useIntl } from "react-intl";
import { Asset } from "../../../../models/asset";
import { SimpleTooltip } from "@rio-cloud/rio-uikit"

export interface IRevisionsProps {
  volksEssentialPlan?: IContractDetailsVolksEssential | null;
  updateMaintenanceGroupButtonAvailable?: boolean;
  setMaintenanceGroupSidebarAsset?: React.Dispatch<React.SetStateAction<Asset | null>>
  setShowMaintenanceGroupSidebarDialog?: React.Dispatch<React.SetStateAction<boolean>>
  asset: Asset
  closeModal: () => void
}

const Revisions = ({ volksEssentialPlan, updateMaintenanceGroupButtonAvailable, setMaintenanceGroupSidebarAsset, setShowMaintenanceGroupSidebarDialog, asset, closeModal }: IRevisionsProps) => {

  const goToGroupMaintenance = () => {
    setMaintenanceGroupSidebarAsset?.(asset)
    closeModal()
    setShowMaintenanceGroupSidebarDialog?.(true)
  }

  const intl = useIntl();

  const getTheRevisionStatus = (isCompleted: boolean, isExpired: boolean) => {
    if(isCompleted) {
      return intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.status.completed" });
    }

    if(!isCompleted && isExpired) {
      return intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.status.expired" });
    }

    if(!isCompleted && !isExpired) {
      return intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.status.notCompleted" });
    }

    return '';
  }

  return (
    <>
      {!volksEssentialPlan?.revision.length ? (
        <div className="flex items-center gap-10 bg-[#F9FAFB] dark:bg-neutral-800 p-4 rounded-lg">
          <img src="/assets/images/settingsicon.png" alt="Revisões" className="w-[26px] h-[26px]" />
          <div>
            <p className="text-[#2A3740] dark:text-neutral-100 font-semibold text-2xl m-0">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.noMaintenanceDefined" })}</p>
            <p className="dark:text-neutral-300">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.noMaintenanceDefinedDescription" })}</p>
          </div>
          {updateMaintenanceGroupButtonAvailable ? (
            <Button
              className="btn w-[300px]"
              onClick={goToGroupMaintenance}
            >
              {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.editMaintenanceGroup" })}
            </Button>
          ) : null}
        </div>
      ) : null}

      {volksEssentialPlan?.revision.length ? (
        volksEssentialPlan?.revision.map((revision, index) => (
          <div className="flex flex-col gap-4 w-full">
            <Card className="flex flex-col w-full margin-bottom-10 !bg-white dark:!bg-neutral-900">
              <div
                className="flex items-center gap-12 px-10 py-8 bg-[#F9FAFB] dark:bg-neutral-800 min-h-[56px]"
              >
                <p className="text-1xl font-semibold text-gray-800 dark:text-neutral-200 whitespace-nowrap">
                    {index + 1}ª {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.maintenance" })}
                </p>

                <p className="text-1xl font-medium text-gray-800 dark:text-neutral-200 m-0 whitespace-nowrap overflow-hidden text-ellipsis">
                    {revision.name}
                </p>

                <div className="flex items-center gap-4">
                  {
                    revision.isCompleted ?
                    <Tag icon='rioglyph rioglyph-ok' size="small" className="available-tag">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.performedSwap" })}</Tag> :
                      revision.isExpired ?
                        <Tag icon='rioglyph rioglyph-remove-sign' size="small" className="overdue-tag">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.performedNotSwap" })}</Tag> :
                          <Tag icon='rioglyph rioglyph-ok' size="small">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.revisions.performedAvailable" })}</Tag>
                  }
                  <SimpleTooltip 
                    content={getTheRevisionStatus(revision.isCompleted, revision.isExpired)}
                    placement='top'>
                    <span className="rioglyph rioglyph-info-sign ml-2 text-[#2A37403D] text-4xl"></span>
                  </SimpleTooltip>
                </div>
              </div>
            </Card>
          </div>
        ))
      ) : null }
    </>
  );
};

export default Revisions;
